module.exports = __webpack_public_path__ + "img/zutto-evolution.9f88faa.jpg";